import {
  AuthenticationTool,
  ChatRenderer,
  ChatRendererProvider,
  createToolRegistry,
  GroupClassesTool,
  MembershipPauseTool,
  MembershipStatusTool,
  MembershipTool,
  OperatorResultTool,
  RagResultTool,
  UsageLimitsErrorTool,
  UserProfileTool,
} from '@form-factory/chatbot-ui';
import type { ChatMessageType } from '@form-factory/schema';
import { ToolNames } from '@form-factory/schema/contracts';

import { AdminFeedback } from './AdminFeedback';

const toolRegistry = createToolRegistry({
  [ToolNames.Membership]: MembershipTool,
  [ToolNames.Authentication]: AuthenticationTool,
  [ToolNames.UserProfile]: UserProfileTool,
  [ToolNames.MembershipStatus]: MembershipStatusTool,
  [ToolNames.MembershipPause]: MembershipPauseTool,
  [ToolNames.RagResult]: RagResultTool,
  [ToolNames.RagResultOperator]: OperatorResultTool,
  [ToolNames.UsageLimitsError]: UsageLimitsErrorTool,
  [ToolNames.GroupClass]: GroupClassesTool,
});

export interface AdminChatRendererProps {
  messages: ChatMessageType[];
  agentName?: string;
  agentAvatar?: string;
}

export function AdminChatRenderer({
  messages,
  agentName,
  agentAvatar,
}: AdminChatRendererProps) {
  return (
    <ChatRendererProvider appearancePreference='light'>
      <ChatRenderer
        messages={messages}
        toolRegistry={toolRegistry}
        FeedbackComponent={AdminFeedback}
        agentName={agentName}
        agentAvatar={agentAvatar}
      />
    </ChatRendererProvider>
  );
}
